import { render, staticRenderFns } from "./serialNumberDialog.vue?vue&type=template&id=59537f09"
import script from "./serialNumberDialog.vue?vue&type=script&lang=js"
export * from "./serialNumberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports